// removed by extract-text-webpack-plugin
module.exports = {"infoBox":"_3fcYIL-1gQxo_ErQzEqLZf"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/CategoryPricingTierInfo.scss
// module id = 734
// module chunks = 0